<template>
  <div class="tableDetail">
    <el-row>
      <el-col>
        <el-form label-width="80px" :inline="true" class="form">
          <el-form-item label="发起机构">
            <patientTree @input="input" :treeData="data"></patientTree>
          </el-form-item>
          <el-form-item label="患者姓名">
            <el-input v-model="listQuery.patientName"></el-input>
          </el-form-item>
          <el-form-item label="协诊人">
            <el-select v-model="listQuery.codiagDoctorName" placeholder="">
              <el-option v-for="(item, index) in codiagDoctorNameOptions" :key="index" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处置方式">
            <el-select v-model="listQuery.codiagDealResult" placeholder="请选择...">
              <el-option v-for="(item, index) in codiagDealResultOptions" :label="item.label" :value="item.value"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="患者执行">
            <el-select v-model="listQuery.isPatientVisitObey" placeholder="请选择...">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="已完成" value="1"></el-option>
              <el-option label="未完成" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="协诊类别">
            <el-select @change="refTypeChange" v-model="listQuery.refType" placeholder="请选择...">
              <el-option v-for="(item, index) in refTypeOptions" :label="item.label" :value="item.value"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="血压类别">
            <el-select :disabled="listQuery.refType !== '血压检测'" v-model="listQuery.refRisk" placeholder="">
              <el-option v-for="(item, index) in refRiskOptions" :label="item.label" :value="item.value"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="协诊时间">
            <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getlistMyCodiagDone">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="reportExportToExcel"
              >导出</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-table v-loading="listLoading" class="inspectionTable" :row-class-name="tableRowClassName" :data="manageList"
          fit highlight-current-row>
          <el-table-column align="center" label="协诊时间">
            <template slot-scope="scope">
              <span>{{ scope.row.codiagTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="处置方式">
            <template slot-scope="scope">
              <span>{{ scope.row.codiagDealResult }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.patientName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="性别">
            <template slot-scope="scope">
              <span>{{ scope.row.gender }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="年龄">
            <template slot-scope="scope">
              <span>{{ getAge(scope.row.birthday) }}</span>
            </template>
          </el-table-column>

          <el-table-column width="110px" align="center" label="电话">
            <template slot-scope="scope">
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="发起人">
            <template slot-scope="scope">
              <span>{{ scope.row.applyDoctorName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="发起机构">
            <template slot-scope="scope">
              <span>{{ scope.row.applyHospital }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="协诊人">
            <template slot-scope="scope">
              <span>{{ scope.row.codiagDoctorName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="协诊机构">
            <template slot-scope="scope">
              <span>{{ scope.row.codiagHospital }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="诊断详情">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="diagnose(scope.row)">诊断详情</el-button>
              <diagnoseDetailDialog v-if="diagnoseVisiaable" ref="diagnoseRef"></diagnoseDetailDialog>
            </template>
          </el-table-column>

          <el-table-column align="center" label="协诊">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="consultationDetail(scope.row)">协诊详情</el-button>
              <consultationDetailDialog v-if="consultationDetailVisiable" ref="consultationDetail">
              </consultationDetailDialog>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="patientsDetail(scope.row)">查看</el-button>
              <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
          @pagination="turnToPage" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import consultationdialog from "./pressureRecordDialogs/consultationdialog.vue"
import consultationDetailDialog from "./pressureRecordDialogs/consultationDetailDialog.vue"
import { getlistMyCodiagDone, turnToMyCodiagDone, getByIdCoDiag, getSearchList, getlistMyDeptDoctorList,reportToExcel } from "@/api/health/Patients";
import patientDetail from "@/views/patient/patientDetail";
import Pagination from "@/components/Pagination";
import diagnoseDetailDialog from "./pressureRecordDialogs/diagnoseDetailDialog.vue";
import patientTree from '@/components/selectTree';
import { Loading } from "element-ui";
import moment from "moment";

export default {
  components: { patientDetail, diagnoseDetailDialog, consultationdialog, Pagination, consultationDetailDialog, patientTree },
  data() {
    return {
      valueData: null,
      manageList: [],
      listLoading: false,
      patientDetailVisible: false,
      diagnoseVisiaable: false,
      consultationVisiable: false,
      consultationDetailVisiable: false,
      codiagDoctorNameOptions: [],
      total: 0,
      data: null,
      loadingOptions: {
        text: "正在导出...",
        background: "rgba(0, 0, 0, 0.6)",
      },
      listQuery: {
        codiagServiceName: '高血压协诊',
        pageNum: 1,
        pageSize: 10,
        patientName: null,
        refRisk: null,
        refType: null,
        isPatientVisitObey: null,
        codiagDealResult: null,
        managerHospitals: [],
        codiagStartTime: null,
        codiagEndTime: null,
        codiagDoctorName: null
      },
      codiagDealResultOptions: [
        {
          value: null,
          label: "全部"
        },
        {
          value: "线上协诊",
          label: "线上协诊"
        },
        {
          value: "门诊",
          label: "门诊"
        },
        {
          value: "住院",
          label: "住院"
        }
      ],
      refTypeOptions: [
        {
          value: null,
          label: "全部"
        },
        {
          value: "血压检测",
          label: "血压检测"
        },
        {
          value: "协诊管理",
          label: "协诊管理"
        }
      ],
      refRiskOptions: [
        {
          value: null,
          label: "全部"
        },
        {
          value: "3",
          label: "红"
        },
        {
          value: "2",
          label: "黄"
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      exportBody: {
        url: "/business/patientCoDiagnosis/listMyCodiagDone",
        headers: ['协诊时间',"处置方式", '姓名', '性别', '年龄', '电话', "发起人", "发起机构", '协诊人', "协诊机构"],
        keys: ['codiagTime',"codiagDealResult", 'patientName', 'gender', 'birthday', 'phone', "applyDoctorName", "applyHospital", 'codiagDoctorName', "codiagHospital"],
        body: null,
      },
    }

  },
  created() {
    this.getlistMyCodiagDone();
    this.getlistMyDeptDoctorList();
  },
  methods: {
    //查询结果导出
    reportExportToExcel() {
      console.log(
        "查询结果导出",
        `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
      );

      let loadingInstance = Loading.service(this.loadingOptions);

      this.exportBody.url = '/business/patientCoDiagnosis/listMyCodiagDone?page=' + this.listQuery.pageNum + '&pageSize=' + this.listQuery.pageSize;

      this.exportBody.body = this.listQuery;
      console.log("导出表格请求body：",this.exportBody);

      reportToExcel(this.exportBody)
        .then((res) => {
          console.log("查询表格导出====", res);

          this.$nextTick(() => {
            loadingInstance.close();
          });

          let blob = new Blob([res], { type: "application/force-download" });
          console.log(blob);
          let fileReader = new FileReader();
          fileReader.readAsDataURL(blob);
          fileReader.onload = (e) => {
            let a = document.createElement("a");
            a.download = `高血压协诊管理-我协诊的${moment(new Date()).format(
              "YYYYMMDDHHmm"
            )}.xlsx`;
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        })
        .catch((error) => {
          this.$nextTick(() => {
            loadingInstance.close();
          });

          console.log(error);

          this.$message({
            message: "导出失败",
            type: "error",
          });
        });
    },
    // 查询协诊人医师列表
    getlistMyDeptDoctorList() {
      getlistMyDeptDoctorList({}).then((res) => {
        if (res.msg == "success") {
          this.codiagDoctorNameOptions = res.data.map((item) => {
            return {
              name: item.name,
              value: item.name
            }
          });
          this.codiagDoctorNameOptions.unshift({ name: "全部", value: null })
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    refTypeChange() {
      this.listQuery.refRisk = null;
    },
    // 选取机构
    input(value) {
      this.listQuery.managerHospitals = value;
    },
    // 协诊完成之后刷新列表
    upDataList() {
      this.turnToPage();
    },
    // 获取我发起的列表
    getlistMyCodiagDone() {
      this.listQuery.codiagStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
      this.listQuery.codiagEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;

      this.listLoading = true;
      getlistMyCodiagDone(this.listQuery).then(res => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      })
    },
    // 跳转协诊记录表
    consultation(data) {
      this.consultationVisiable = true;
      this.$nextTick(() => {
        this.$refs["consultation"].init(data)
      })
    },
    // 跳转协诊详情
    consultationDetail(data) {
      this.consultationDetailVisiable = true;
      const params = {
        id: data.id
      }
      getByIdCoDiag(params).then(res => {
        if (res.msg == "success") {
          this.$nextTick(() => {
            this.$refs["consultationDetail"].init(res.data)
          })
        }
      })
    },
    // 計算年齡
    getAge(birthday) {
      if (birthday == null) return "";
      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    // 修改条纹颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.isPatientVisitObey == 0) {
        return 'light-row'
      } else {
        return;
      }
    },
    // 跳转诊断列表
    diagnose(rowValue) {
      this.diagnoseVisiaable = true;
      this.$nextTick(() => {
        this.$refs.diagnoseRef.init(rowValue);
      })
    },
    // 跳转至相应病人档案详情页
    patientsDetail(row) {
      let params = {
        healthNo: row.healthNo
      }
      getSearchList(params).then((res) => {
        if (res.msg == "success") {
          console.log("========", res, row)
          var data = res.data.records[0];
          this.patientDetailVisible = true;
          this.$nextTick(() => {
            this.$refs["PatientDetailRef"].init(data);
          });
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    // 导航跳转查询列表页
    turnToPage() {
      this.listLoading = true;
      this.listQuery.codiagStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
      this.listQuery.codiagEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;

      turnToMyCodiagDone(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 日期格式转化
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
  }
}
</script>
<style lang="scss" scoped>
.inspectionTable {
  ::v-deep {
    .light-row {
      background: rgba(255, 0, 0, 0.579) !important;
    }

    .el-table__cell {
      height: 50px !important;
    }
  }

}


.form {
  display: flex;
  flex-wrap: wrap;
  margin-top: 22px;


  // ::v-deep {
  //   .el-form-item__content {
  //     display: inline-flex;
  //   }
  // }
}
</style>